<template>
  <div>
    <NavigationDashboard />
  </div>
</template>

<script setup lang="ts">
// Page meta
useSeoMeta({
  title: "Dashboard - Apex CMS",
  description: "Your comprehensive content management system dashboard",
})
</script>
<style scoped></style>
